import React, { Suspense, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Loader } from '@playbookux/playbook-web-core';

import Tabs from '../../constants/tabs';
import withLayout from '../../../core/components/with-layout';

import {
  LoaderContainer,
} from './styles';

/* eslint-disable import/no-unresolved */
const Setup = React.lazy(() => import('playbook-mf-create-project/Setup'));
const Details = React.lazy(() => import('playbook-mf-create-project/Details'));
const UploadDetails = React.lazy(() => import('playbook-mf-create-project/UploadDetails'));
const Summary = React.lazy(() => import('playbook-mf-create-project/Summary'));
const Audience = React.lazy(() => import('playbook-mf-create-project/Audience'));
const TreeTest = React.lazy(() => import('playbook-mf-create-project/TreeTest'));
const CardSort = React.lazy(() => import('playbook-mf-create-project/CardSort'));
const Tasks = React.lazy(() => import('playbook-mf-create-project/Tasks'));
const Instructions = React.lazy(() => import('playbook-mf-create-project/Instructions'));
const BuildStudy = React.lazy(() => import('playbook-mf-create-project/BuildStudy'));
const Survey = React.lazy(() => import('playbook-mf-create-project/Survey'));

const CreateProjectV2 = (props) => {
  const {
    location,
  } = props;

  let component = <></>;
  const page = location.pathname.split('/').pop('/');

  switch (page) {
    case 'project-set-up':
      component = <Setup />;
      break;

    case 'audience':
      component = <Audience />;
      break;

    case 'tree-test':
      component = <TreeTest />;
      break;

    case 'cards':
      component = <CardSort />;
      break;

    case 'tasks':
      component = <Tasks />;
      break;

    case 'summary':
      component = <Summary />;
      break;

    case 'instructions':
      component = <Instructions />;
      break;

    case 'build-study':
      component = <BuildStudy />;
      break;

    case 'survey':
      component = <Survey />;
      break;
    case 'upload-details':
      component = <UploadDetails />;
      break;
    case 'details':
    default:
      component = <Details />;
      break;
  }

  // eslint-disable-next-line arrow-body-style
  useEffect(() => {
    // Cleanup on component unmount
    return () => {
      /**
       * Prepare for long story why we are doing this when the fonts/size changes
       * When we are using Module Federation and playbook-web with playbook-web-core for both sides
       * the styled-components have some issues that i found:
       * 1. collision of hashes
       * 2. doesnt work well for module federation
       * 3. semantic ui css is overriding the styled-components css
       * So to prevent the hash collision (1st item), we had to downgrade the styled-components of mf-create-project
       * to 4.4.1 because the hash is different
       * The 2nd item, it is because we wanted to share the styled-components in module federation and we cant
       * because the styled-components always give us different errors like "module is not a function" together with a library
       * playbook-web-core, also we had to change the hash from the mf-create-project
       * For the 3rd item, we need to dismount the semantic ui css from the mf-create-project
       * because it is overriding the styled-components
       */
      const stylesWithComment = document.querySelectorAll('style');
      const elementsWithComment = [];
      if (stylesWithComment && stylesWithComment.length > 0) {
        stylesWithComment.forEach((element) => {
          if (element.textContent.includes('# Semantic UI 2.5.0 - Reset')) {
            elementsWithComment.push(element);
          }
        });
        // Remove the last occurrence if there are multiple instances
        if (elementsWithComment.length > 1) {
          const lastElement = elementsWithComment.pop();
          lastElement.parentNode.removeChild(lastElement);
        }
      }
    };
  }, []);

  const fallbackContent = (
    <LoaderContainer>
      <Loader data-loader="create-project-v2-loader" />
    </LoaderContainer>
  );

  return (
    <Suspense fallback={fallbackContent}>
      {component}
    </Suspense>
  );
};

CreateProjectV2.propTypes = {
  location: PropTypes.shape().isRequired,
};

export default withLayout({ selectedTab: Tabs.PROJECT })(CreateProjectV2);
